module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAoCAYAAADkDTpVAAAA/ElEQVRYR83XPQrCQBCG4W88guBpPICFeB1RGws7PZBgo+BhPITFyEo2GJJsdv7ANAksvA/sFpshBD+U+sy8BLBLnwAuRPT0cjNwBbBoom8AeyJ6eCAZuAGY/wQTciCiuxXJwArACcDMG/kCzTmsARy9kRaIQjpABNIDvJFBwBMZBbyQIuCBTAJWpAqwINWAFhEBGkQMSBEVIEHUwASyzZeWCSggLyLapPX/Bph57A6xb1Eh3rlqVVtUG1edgSQuBqRxEaCJVwPaeBVgiU8C1ngR8IiPAl7xQcAz3gO84x0gIt4CzBz7+87M4QNI+AiVh8C0bWf3IbAZckJeH9I44SlEeDKjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_carousel_right_white.png
// module id = LPuq
// module chunks = 1